import { render, staticRenderFns } from "./friendContentH5.vue?vue&type=template&id=ec7fa130"
import script from "./friendContentH5.vue?vue&type=script&lang=js"
export * from "./friendContentH5.vue?vue&type=script&lang=js"
import style0 from "./friendContentH5.vue?vue&type=style&index=0&id=ec7fa130&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports